import getConfig from 'next/config';
import { configureClient } from '@tmap/mmm-core/apiClient';
import { storeRef } from '../store';

const getState = () => storeRef.current.getState();
export const getClient = configureClient(getState, getConfig);
